<template>
  <div class="form-step-2">
    <app-address-form-partial
      class="form-step-2__address"
      ref="form"
      :field-name="fields.clubAddress.name"
      :address.sync="clubAddress"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

import { FormSchema } from '@shared/form/form-schema'

import { TeamRegistrationModel } from '@/models/team-registration-model'

import { generateVuexStateComputed } from '@/helpers/generateVuexStateComputed'

const { fields } = TeamRegistrationModel

const formSchema = new FormSchema([
  fields.clubAddress,
])

export default {
  name: 'appFormStep2',
  data() {
    return {
      fields,
      rules: formSchema.rules(),
    }
  },
  computed: {
    ...mapGetters('teamRegistration', ['model']),
    clubAddress: generateVuexStateComputed('clubAddress'),
  },
  async mounted() {
    await this.$nextTick()
    this.setCurrentStepValidate(this.$refs.form.$refs.form.validate)
  },
  methods: {
    ...mapMutations('form', ['setCurrentStepValidate']),
  },
}
</script>

<style lang="scss" scoped>
.form-step-2 {
  text-align: center;

  &__address.form--partial {
    margin: 0;
  }
}
</style>
